module.exports = __webpack_public_path__ + "fonts/proximanova-reg-webfont.svg";